export const browserIsSafari = /^((?!chrome|android).)*safari/i.test(
  navigator.userAgent
);
